import * as Yup from 'yup';
import { idStore } from '@pharmaplan/common/helpers/ServiceHandler';
import { HelpTypes } from '@pharmaplan/common';
import strings from '../../../../../localization';
import {
  nameRegex,
  onlyNumbersRegex,
  postalCodeRegExp,
} from '../../../../../helpers/Constants';
import { bankAccountValidations, incorporatedProfessionalValidator, numberValidation } from '../../../../../helpers/commonValidators';

const technicianBasedValidation = () =>
  Yup.string().nullable().when('role', {
    is: (values: HelpTypes) =>
      `${values}` === HelpTypes.technicians,
    then: () =>
      Yup.string().trim().required(strings.requiredField),
  });

const selfValidation = {
  ...bankAccountValidations,
  ...incorporatedProfessionalValidator(),
  diploma: technicianBasedValidation(),
  instituteName: technicianBasedValidation(),
  techGraduationYear: technicianBasedValidation(),
};

const PharmacistEditProfileValidator = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    lastName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    preferdLanguage: Yup.string().required(strings.requiredField),
    licenseNumber: Yup.string().nullable().when('role', {
      is: (values: HelpTypes) =>
        `${values}` === HelpTypes.pharmacist,
      then: () =>
        Yup.string().matches(
          onlyNumbersRegex,
          strings.formatString(
            strings.numberValidation,
            strings.licenseNo,
          ) as string,
        )
          .required(strings.requiredField),
    }),
    [idStore.capacityId]: Yup.string().required(strings.requiredField),
    graduationYear: Yup.string().nullable().when('role', {
      is: (values: HelpTypes) =>
        `${values}` !== HelpTypes.students,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
    otherLanguages: Yup.string().nullable(),
    province: Yup.string().required(strings.requiredField),
    address: Yup.string().required(strings.requiredField),
    city: Yup.string().required(strings.requiredField),
    prefferedDistanceRange: numberValidation.nullable(),
    postalCode: Yup.string()
      .required(strings.requiredField)
      .matches(postalCodeRegExp, strings.postalCodeValidation),
    phone: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(
          strings.phoneValidation,
          strings.homePhone,
        ) as string,
      ),
    mobile: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      ),
    ...selfValidation,
  });

export default PharmacistEditProfileValidator;
